import { Paper, styled } from '@mui/material'

export const StyledPaper = styled(Paper)`
  padding: 30px 20px;
  height: 100%;
  /** 128px 分别是全局 padding top 的 64px（包含 40px 的 header）和 padding bottom 的 64px */
  min-height: calc(100vh - 128px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`
